// import React from "react";
// import useThemeHook from "../Theme/ThemeFile";
// import { Link, useLocation } from "react-router-dom";
// import logo from "../../assests/logo/logo.png";

// const Header = () => {
//   const Theme = useThemeHook();
//   const colorScheme = Theme?.theme ?? {};
//   const location = useLocation(); // Add this line

//   const links = [
//     { lable: "Home", link: "/" },
//     { lable: "What is ico", link: "/" },
//     { lable: "Product", link: "/" },
//     { lable: "Token", link: "/" },
//     { lable: "Road Map", link: "/" },
//     { lable: "Team", link: "/" },
//     { lable: "Contact Us", link: "/" },

//     // { lable: "Presale", link: "/presale" },
//     // { lable: "Staking", link: "/staking" },
//   ];

//   return (
//     <div
//       className="w-full sticky top-0 z-50"
//       style={{
//         background: colorScheme?.background,
//         color: colorScheme?.textPrimary,
//         border: `1px solid ${colorScheme?.border}`,
//       }}
//     >
//       <div className="hidden sm:block">
//         <div className="w-[80%] mx-auto flex justify-between items-center py-2 ">
//           <div className="flex justify-center items-center gap-1">
//             <img src={logo} alt="logo" className="w-[60px]" />
//             <h1 className="font-bold sm:text-[1.5rem] uppercase">
//               Student Cafe
//             </h1>
//           </div>
//           <div className="flex justify-center items-center gap-10">
//             {links?.map((el, index) => {
//               const isActive = location.pathname === el.link;
//               return (
//                 <Link
//                   key={index}
//                   to={el.link}
//                   className="transition-colors duration-300 font-medium"
//                   style={{
//                     color: isActive
//                       ? colorScheme?.ActiveLink || "red"
//                       : colorScheme?.textPrimary,
//                   }}
//                 >
//                   {el.lable}
//                 </Link>
//               );
//             })}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Header;

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assests/logo/logo.png";
import { getIcon } from "../Custom/IconFile";
import useThemeHook from "../Theme/ThemeFile";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const BASE_URL = `${window.location.origin}/student/index.html`;
  const Theme = useThemeHook();
  const colorScheme = Theme?.theme ?? {};
  const { ActiveLinkheader, textPrimary, headerBg } = colorScheme;

  const location = useLocation();
  const links = [
    { label: "Home", href: `${BASE_URL}` },
    { label: "What is ico", href: `${BASE_URL}#ico` },
    { label: "Product", href: `${BASE_URL}#product` },
    { label: "Token", href: `${BASE_URL}#token` },
    { label: "Road Map", href: `${BASE_URL}#road` },
    { label: "Team", href: `${BASE_URL}#team` },
    { label: "Contact Us", href: `${BASE_URL}#contact` },
    { label: "Presale", href: "/presale" },
    { label: "Staking", href: "/staking" },
  ];

  return (
    <header
      className="  shadow sticky top-0 z-50"
      style={{ background: headerBg, textPrimary }}
    >
      <div className="mx-auto xl:px-[80px] lg:px-[30px] pt-2 px-[15px]  flex flex-col lg:flex-row    items-center justify-between ">
        {/* Logo */}
        <div className="flex items-center lg:justify-start justify-between lg:w-fit w-full">
          <Link to="#" className="flex items-center gap-2">
            {/* <img src={logo} alt="logo" className="lg:h-[100px] h-[80px]" /> */}
            <img src={logo} alt="logo" className="lg:h-[70px] h-[60px]" />
          </Link>

          {/* Hamburger Toggle (Mobile) */}
          <button
            className="lg:hidden text-2xl"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <p className="px-2 py-[4px] border rounded-md">
              {getIcon("PiListLight", "pi", 25, "#fff")}
            </p>
          </button>
        </div>

        {/* Nav Links */}
        <nav
          className={
            "lg:block hidden  lg:items-center w-full lg:w-auto mt-4 lg:mt-0"
          }
        >
          <ul className="flex flex-col lg:flex-row gap-4 xl:gap-10 lg:gap-6 lg:ml-auto">
            {links?.map((el, idx) => {
              const isInternalLink = el.href.startsWith("/");
              const isHashLink = el.href.includes("#");

              const isActive = isInternalLink
                ? location.pathname === el.href
                : isHashLink
                ? window.location.hash === el.href.split("#")[1]
                  ? `#${window.location.hash}`
                  : ""
                : false;
              return (
                <li key={idx}>
                  <Link
                    to={el.href}
                    style={{
                      color: isActive
                        ? ActiveLinkheader || "#21205E"
                        : textPrimary || "#ffffff",
                    }}
                    className="hover:text-[#21205E] transition-colors font-medium"
                  >
                    {el.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
        {/* mobile  */}
        {menuOpen && (
          <nav
            className={
              "lg:hidden  w-full  mt-4 lg:mt-0  bg-[#666666] rounded-md"
            }
          >
            <ul className="flex flex-col lg:flex-row     px-4 py-2 gap-4">
              {links?.map((el, idx) => {
                const isInternalLink = el.href.startsWith("/");
                const isHashLink = el.href.includes("#");

                const isActive = isInternalLink
                  ? location.pathname === el.href
                  : isHashLink
                  ? window.location.hash === el.href.split("#")[1]
                    ? `#${window.location.hash}`
                    : ""
                  : false;
                return (
                  <li key={idx}>
                    <Link
                      to={el.href}
                      style={{
                        color: isActive
                          ? ActiveLinkheader || "#21205E"
                          : textPrimary || "#ffffff",
                      }}
                      className="hover:text-[#21205E] transition-colors font-medium"
                      onClick={() => setMenuOpen(false)}
                    >
                      {el.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
